import { parseAsStringEnum, useQueryState } from "nuqs";

export enum ProfileType {
  Velocity = "velocity",
  Power = "power",
}

function useProfileTypeQueryState() {
  return useQueryState(
    "profileType",
    parseAsStringEnum<ProfileType>(Object.values(ProfileType)).withDefault(ProfileType.Velocity)
  );
}

export default useProfileTypeQueryState;
